let isLoggingOut = false;

const HandleLogout = () => {
  // Guard against multiple simultaneous logout calls creating a redirect loop
  if (isLoggingOut) return;
  isLoggingOut = true;

  localStorage.removeItem("dwt-cust-tok");
  localStorage.removeItem("customer-name");
  localStorage.removeItem("phone_number");
  localStorage.removeItem("event-info");

  try {
    localStorage.setItem("logout", Date.now().toString());
  } catch (e) {
    // ignore storage write failure
  }

  // Use replace instead of reload to prevent WebView reload loops
  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};

export default HandleLogout;
